import { API } from "aws-amplify";
import dayjsTZ from "../../../../../../utils/dayjs";
import swal from "sweetalert";
import { requestData } from "../../../../../../helpers/API/RequestFactory";
import {
  dayCalculateFactory,
  mergeManualTotalities,
} from "../../../../../Pagat/PaySub/employeeCalc/dayCalculateFactory";
import axios from "axios";
import { getAbsencePunch } from "../../../../../Pagat/approvals/absenceShift";
export const editShift = async (
  clockingId,
  shiftData,
  employeeId,
  adminLog,
) => {
  // console.log("to send", dayjsTZ(shiftData.clockInDate).format("DD/MM/YYYY HH:mm"));
  // console.log("Adming Log", adminLog);
  let valid = await validateCrashingShifts(shiftData, employeeId, clockingId);
  const res = await axios.get("https://api.ipify.org/?format=json");
  // console.log("valid", valid);

  let clockInDate = dayjsTZ(shiftData.clockInDate);
  clockInDate = clockInDate
    .set("hour", clockInDate.get("hour"))
    .set("minute", clockInDate.get("minute"))
    .set("second", "00");

  let clockOutDate = dayjsTZ(shiftData.clockOutDate);
  clockOutDate = clockOutDate
    .set("hour", clockOutDate.get("hour"))
    .set("minute", clockOutDate.get("minute"))
    .set("second", "00");

  if (valid.value === true) {
    let amounts = await dayCalculateFactory({
      ...shiftData,
      employeeId,
      clockingId,
      clockInDate: dayjsTZ(clockInDate).valueOf(),
      clockOutDate: dayjsTZ(clockOutDate).valueOf(),
    });
    console.log({ amounts });
    const clockingToSend = {
      ...shiftData,
      clockInDate: dayjsTZ(clockInDate).valueOf(),
      clockOutDate: dayjsTZ(clockOutDate).valueOf(),
      totalities: mergeManualTotalities(amounts || {}, shiftData?.totalities),
    };
    await API.put("clocking", `/clocking/${clockingId}`, {
      body: { ...clockingToSend },
    })
      .then(async () => {
        await API.post("clockingLogs", "/clockingLogs", {
          body: {
            ...adminLog,
            clockingId,
            ipResponse: { ...adminLog.ipResponse, IPv4: res?.data?.ip },
            newShift: [
              {
                clockInDate: dayjsTZ(clockInDate).valueOf(),
                clockOutDate: dayjsTZ(clockOutDate).valueOf(),
                dayType: shiftData?.dayType,
                clockingCategory: shiftData?.clockingCategory,
              },
            ],
          },
        }).then((res) => console.log("Success log", res));
      })
      .catch((err) => {
        console.log(err);
      });
    return { ...clockingToSend, clockingId };
  } else {
    return Promise.reject([valid.crashShift, shiftData]);
  }
};
export const getShift = async (clockingId) => {
  return await API.get("clocking", `/clocking/${clockingId}`);
};
export const validateCrashingShifts = async (
  shiftData,
  employeeId,
  clockingId,
) => {
  console.log("Shift Data", shiftData);
  let clockings;
  let res = { value: true, crashShift: {} };
  let startTimeInstance = dayjsTZ(shiftData.clockInDate)
    .startOf("day")
    .valueOf();
  let endTimeInstance = dayjsTZ(shiftData.clockInDate).endOf("day").valueOf();
  const fetched = await requestData("clocking", { employeeId }).catch((err) => {
    console.log("error on requestData", err);
    return null;
  });
  //a failed fetch used to leave clockings undefined and throw a TypeError below, which
  //reached the caller as a crash-shift error - a network problem was reported to the
  //admin as a shift collision. Refuse the write instead, we cannot verify anything.
  if (!Array.isArray(fetched)) {
    return Promise.reject(
      new Error("Nuk u verifikuan dot turnet ekzistuese. Provoni përsëri."),
    );
  }
  clockings = fetched.filter(
    (el) =>
      el.clockInDate > startTimeInstance &&
      el.clockInDate < endTimeInstance &&
      el.clockingId !== clockingId,
  );
  if (clockings.length > 0) {
    clockings.forEach((el) => {
      if (
        (el.clockInDate <= shiftData.clockInDate &&
          shiftData.clockInDate <= el.clockOutDate) ||
        (el.clockInDate <= shiftData.clockOutDate &&
          shiftData.clockOutDate <= el.clockOutDate) ||
        (shiftData.clockInDate <= el.clockInDate &&
          shiftData.clockOutDate >= el.clockInDate) ||
        (el.clockInDate <= shiftData.clockInDate &&
          el?.clockOutDate === null &&
          !shiftData.clockOutDate)
      ) {
        res = { value: false, crashShift: el }; // new edited shift is between an old shift, return false & shift (one shift)
      }
    });
    return res;
  } else {
    return { value: true };
  }
};
//plain async function on purpose: wrapping this in `new Promise(async ...)` swallowed
//every rejection, so a failed calculation or PUT left the promise pending forever and
//the caller's loading spinner never resolved
export const approveShift = async (clocking, adminLog) => {
  const amounts = await dayCalculateFactory({
    ...clocking,
    clockInDate: clocking?.clockInDate,
    clockOutDate: dayjsTZ(clocking?.clockOutDate).valueOf(),
  });
  const toSend = {
    approved: true,
    totalities: {
      ...mergeManualTotalities(amounts || {}, clocking?.totalities),
      adminLog,
    },
  };
  await API.put("clocking", `/clocking/${clocking?.clockingId}`, {
    body: { ...toSend },
  });
  return { ...clocking, ...toSend };
};
export const disapproveShift = async (clocking, adminLog) => {
  const toSend = {
    approved: false,
    totalities: {
      ...(clocking?.totalities || {}),
      adminLog: adminLog,
    },
  };
  await API.put("clocking", `/clocking/${clocking?.clockingId}`, {
    body: { ...toSend },
  });
  return { ...clocking, ...toSend };
};
//Promise.all rejected the whole batch on the first failure, so one bad PUT meant the
//grid was never refreshed and the admin saw nothing at all. allSettled lets the shifts
//that did succeed be reported and refreshed.
const settleShifts = async (shiftsArr, handler) => {
  const shifts = shiftsArr || [];
  const settled = await Promise.allSettled(shifts.map((el) => handler(el)));

  const ok = [];
  const failed = [];
  settled.forEach((result, idx) => {
    if (result.status === "fulfilled") {
      ok.push(result.value);
    } else {
      failed.push({ shift: shifts[idx], error: result.reason });
    }
  });
  return { ok, failed };
};

const reportSettled = ({ ok, failed }, { success, partial, error }) => {
  if (!failed.length) {
    swal({ title: success, icon: "success", className: "custum-swal" });
  } else {
    console.log("failed shifts", failed);
    swal({
      title: !!ok.length ? partial(ok.length, failed.length) : error,
      icon: !!ok.length ? "warning" : "error",
      className: "custum-swal",
    });
  }
};

//List of Promises
export const approveShifts = async (shiftsArr, adminLog) => {
  const results = await settleShifts(shiftsArr, (el) =>
    approveShift(el, adminLog),
  );
  reportSettled(results, {
    success:
      shiftsArr?.length === 1
        ? "Turni u aprovua me sukses!"
        : "Turnet u aprovuan me sukses!",
    partial: (okCount, failedCount) =>
      `${okCount} turne u aprovuan, ${failedCount} dështuan!`,
    error: "Aprovimi i turneve dështoi!",
  });
  return results;
};
export const disapproveShifts = async (shiftsArr, adminLog) => {
  const results = await settleShifts(shiftsArr, (el) =>
    disapproveShift(el, adminLog),
  );
  reportSettled(results, {
    success:
      shiftsArr?.length === 1
        ? "Turnit ju hoq aprovimi me sukses!"
        : "Turneve u hoqën aprovimet me sukses!",
    partial: (okCount, failedCount) =>
      `${okCount} turneve u hoq aprovimi, ${failedCount} dështuan!`,
    error: "Heqja e aprovimit dështoi!",
  });
  return results;
};

//region BULK DAYTYPE
//editShift() re-fetches ipify, the employee, programFields and the employee's whole
//clocking history for every single shift - roughly six round trips each. Everything
//except the PUT and the log POST is shared across a batch, so it is hoisted up here.
export const editShiftsDayType = async (
  shifts,
  { dayType, isAbsence = false },
  adminLog,
) => {
  const toEdit = (shifts || []).filter((el) => !!el?.clockingId);
  if (!toEdit.length) return { ok: [], failed: [] };

  const ip = await axios
    .get("https://api.ipify.org/?format=json")
    .then((res) => res?.data?.ip || null)
    .catch(() => null);

  const upperCoefficients = await API.get("programFields", "/programFields")
    .then(
      (res) =>
        res?.find(({ fieldName }) => fieldName === "ClockIn Types")
          ?.fieldOptions,
    )
    .catch(() => null);

  const employeeIds = [...new Set(toEdit.map((el) => el?.employeeId))].filter(
    Boolean,
  );
  const employees = {};
  await Promise.all(
    employeeIds.map(async (id) => {
      employees[id] = await API.get("employees", `/employees/${id}`).catch(
        () => null,
      );
    }),
  );

  return await settleShifts(toEdit, async (shift) => {
    //an absence has no punch times: the shift collapses onto its day with 0 hours
    const punches = isAbsence
      ? {
          clockInDate: getAbsencePunch(shift?.clockInDate),
          clockOutDate: getAbsencePunch(shift?.clockInDate),
        }
      : {};
    //times only ever shrink to a zero-length point here, so validateCrashingShifts has
    //nothing to check - and it would refuse the edit outright for employees who already
    //have overlapping rows
    const amounts = await dayCalculateFactory(
      { ...shift, ...punches, dayType },
      {
        employee: employees[shift?.employeeId] || undefined,
        upperCoefficients: upperCoefficients || undefined,
      },
    );

    const toSend = {
      editedByAdmin: true,
      dayType,
      ...punches,
      totalities: mergeManualTotalities(amounts || {}, shift?.totalities),
    };

    await API.put("clocking", `/clocking/${shift?.clockingId}`, {
      body: { ...toSend },
    });
    await API.post("clockingLogs", "/clockingLogs", {
      body: {
        ...adminLog,
        clockingId: shift?.clockingId,
        employeeId: shift?.employeeId,
        oldShift: [{ ...shift, clockingLogs: [] }], //API constraints, same as editShift
        ipResponse: { ...(adminLog?.ipResponse || {}), IPv4: ip },
        newShift: [
          {
            clockInDate: shift?.clockInDate,
            clockOutDate: shift?.clockOutDate,
            ...punches,
            dayType,
            clockingCategory: shift?.clockingCategory,
          },
        ],
      },
    }).catch((err) => console.log("clockingLogs error", err));

    return { ...shift, ...toSend };
  });
};
// Logs for Shift!
export const getLogsPerShift = async (clockingId) => {
  // const config = {
  // 	queryStringParameters: {
  // 		tableName: process.env.NODE_ENV === "production" ? "clockingLogs-prod" : "clockingLogs",
  // 		filterKey: "clockingId",
  // 		filterValue: `${clockingId}`,
  // 	},
  // };
  return await API.get("clockingLogs", "/clockingLogs").then((res) =>
    res?.filter((el) => el?.clockingId === clockingId),
  );
};
export const getAllUsers = async () => {
  return await API.get("users", "/users").then((res) => res);
};
export const deleteShift = async (clockingId) =>
  await API.del("clocking", `/clocking/${clockingId}`);

export const deleteClockIns = async (shiftsArr, callback) => {
  const ids = (Array.isArray(shiftsArr) ? shiftsArr : [])
    .map((el) => el?.clockingId)
    .filter(Boolean);
  if (!ids.length) return { deleted: [], failed: [] };

  const settled = await Promise.allSettled(ids.map((id) => deleteShift(id)));
  const deleted = [];
  const failed = [];
  let firstError;
  settled.forEach(({ status, reason }, idx) => {
    if (status === "fulfilled") {
      deleted.push(ids[idx]);
    } else {
      failed.push(ids[idx]);
      firstError = firstError || reason;
      // console.log is disabled in production, console.error is not
      console.error("deleteShift failed", ids[idx], reason);
    }
  });

  if (!!deleted.length) callback && callback(deleted);

  if (!failed.length) {
    swal({
      title: `${
        deleted.length === 1
          ? "Turni u fshi me sukses!"
          : "Turnet u fshinë me sukses!"
      }`,
      icon: "success",
      className: "custum-swal",
    });
  } else {
    const status = firstError?.response?.status;
    swal({
      title: "Fshirja dështoi!",
      text: `${failed.length} nga ${ids.length} turne nuk u fshinë. Serveri ktheu një gabim${
        status ? ` (${status})` : ""
      }.`,
      icon: "error",
      className: "custum-swal",
    });
  }
  return { deleted, failed };
  // let promises = await shiftsArr.map(async (el) =>
  // 	setTimeout(async () => {
  // 		return await deleteShift(el.clockingId);
  // 	}, 500)
  // );
  // Promise.all(promises).then(() =>
  // 	swal({
  // 		title: `${shiftsArr.length === 1 ? "Turni u fshi me sukses!" : "Turnet u fshine me sukses!"}`,
  // 		icon: "success",
  // 		className: "custum-swal",
  // 	})
  // );
};
